function isEqual(valueA, valueB) {
  return valueA?.value === valueB?.value;
}

export default isEqual;
